// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { staticListHeaderStyles } from "@insite/content-library/Widgets/StaticList/StaticListHeader";
import { xScreen } from "@keller/XDL/Utilities";
import { modalButtonsActionStyles } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

staticListHeaderStyles.listNameTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 8px;
            width: 100%;
        `,
        formField: css`
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            width: 100%;
            max-width: 300px;
            ${xScreen("lte", "xs")} {
                max-width: none;
            }
        `,
    },
    labelProps: {
        css: css`
            text-align: left;
            padding: 0;
        `,
    },
};

staticListHeaderStyles.buttonsWrapper = {
    css: css`
        margin-top: 30px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
    `,
};

staticListHeaderStyles.cancelButton = modalButtonsActionStyles.cancelButton;

staticListHeaderStyles.saveButton = modalButtonsActionStyles.submitButton;
